export const weekDays = [
  {
    label: 'Segunda-feira',
    compactLabel: 'Segunda',
    weekDay: 1,
  },
  {
    label: 'Terça-feira',
    compactLabel: 'Terça',
    weekDay: 2,
  },
  {
    label: 'Quarta-feira',
    compactLabel: 'Quarta',
    weekDay: 3,
  },
  {
    label: 'Quinta-feira',
    compactLabel: 'Quinta',
    weekDay: 4,
  },
  {
    label: 'Sexta-feira',
    compactLabel: 'Sexta',
    weekDay: 5,
  },
  {
    label: 'Sábado',
    compactLabel: 'Sábado',
    weekDay: 6,
  },
  {
    label: 'Domingo',
    compactLabel: 'Domingo',
    weekDay: 0,
  },
];

export type IWeek = {
  name: string;
  slug: string;
}

export const weeks: IWeek[] = [
  {
    name: 'Semana 1',
    slug: 'semana_1',
  },
  {
    name: 'Semana 2',
    slug: 'semana_2',
  },
  {
    name: 'Semana 3',
    slug: 'semana_3',
  },
  {
    name: 'Semana 4',
    slug: 'semana_4',
  },
  {
    name: 'Semana 5',
    slug: 'semana_5',
  },
  {
    name: 'Semana 6',
    slug: 'semana_6',
  },
  {
    name: 'Semana 7', 
    slug: 'semana_7',
  },
  {
    name: 'Semana 8',
    slug: 'semana_8',
  },
  {
    name: 'Semana 9',
    slug: 'semana_9',
  },
  {
    name: 'Semana 10',
    slug: 'semana_10',
  },
  {
    name: 'Semana 11',
    slug: 'semana_11',
  },
  {
    name: 'Semana 12',
    slug: 'semana_12',
  },
  {
    name: 'Semana 13',
    slug: 'semana_13',
  },
  {
    name: 'Semana 14',
    slug: 'semana_14',
  },
  {
    name: 'Semana 15',
    slug: 'semana_15',
  }
];

export type IDiscipline = {
  discipline: string;
  disciplineSlug: string;
}

export const disciplines: IDiscipline[] = [
  {
    discipline: 'Redação',
    disciplineSlug: 'redacao',
  },
  {
    discipline: 'Biologia',
    disciplineSlug: 'biologia',
  },
  {
    discipline: 'Matemática',
    disciplineSlug: 'matematica',
  },
  {
    discipline: 'Química',
    disciplineSlug: 'quimica',
  },
  {
    discipline: 'Física',
    disciplineSlug: 'fisica',
  },
  {
    discipline: 'Geografia',
    disciplineSlug: 'geografia',
  },
  {
    discipline: 'História',
    disciplineSlug: 'historia',
  },
  {
    discipline: 'Filosofia',
    disciplineSlug: 'filosofia',
  },
  {
    discipline: 'Sociologia',
    disciplineSlug: 'sociologia',
  },
  {
    discipline: 'Português',
    disciplineSlug: 'portugues',
  },
  {
    discipline: 'Literatura',
    disciplineSlug: 'literatura',
  },
  {
    discipline: 'Inglês',
    disciplineSlug: 'ingles',
  },
  {
    discipline: 'Espanhol',
    disciplineSlug: 'espanhol',
  },
];

export const getDayByWeekDay = (weekDay: string) => {
  switch (weekDay) {
    case 'terça':
      return 'terca';
    case 'sábado':
      return 'sabado';
    default:
      return weekDay;
  }
}

export const getScheduleCreatingStatus = () => {
  const schedule = localStorage.getItem('schedule');

  if (!schedule) return false;

  const scheduleData = JSON.parse(schedule);
  const is24Hours = new Date(scheduleData.date).getTime() + 24 * 60 * 60 * 1000 > new Date().getTime();

  if (!is24Hours) {
    localStorage.removeItem('schedule');
    return false;
  }

  return scheduleData.isCreating;
}

export const formatTime = (time: number) => {
  const hours = Math.floor(time / 3600);

  return hours;
}
export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}